import React, { useState, useRef, useEffect, memo } from "react";
import Draggable from "react-draggable";
import { uuid } from "uuidv4";
import Axios from "axios";
import { useMyPresence, useOthers, useSelf } from "@liveblocks/react";

import * as rrweb from "rrweb";

import CanvasHeaderWrapper from "./components/Header";
import KlenRecorder from "./components/KlenRecorder";

import TextComponent from "./components/blocks/TextComponent";
import Shapes from "./components/blocks/ShapesComponent";

import "./canvas.styles.css";
import ImageUploader from "../../components/ImageUploader";

import { data } from "./data";
import Editor from "./components/blocks/Editor";

import "./canvas.styles.css";

import Cursor from "../../Cursor";
import useWindowLiveCursors from "../../useWindowLiveCursors";
import BlockFormatter from "./components/blocks/Formatter/BlockFormatter";
const COLORS = ["#DC2626", "#D97706", "#059669", "#7C3AED", "#DB2777"];
const IMAGE_SIZE = 48;

function mouseEventToContainerPoint(event, containerRef) {
  if (!containerRef.current) {
    return null;
  }
  const boundingRectangle = containerRef.current.getBoundingClientRect();
  return {
    x: event.clientX - boundingRectangle.x,
    y: event.clientY - boundingRectangle.y,
  };
}

const Canvas = () => {
  const users = useOthers().toArray();
  const currentUser = useSelf();
  const hasMoreUsers = users.length > 3;
  const [presence, updateMyPresence] = useMyPresence();
  const others = useOthers();
  const cursors = useWindowLiveCursors();
  const containerRef = useRef(null);

  const [selectedBlocks, setSelectedBlocks] = useState(null);

  const [recordStart, setRecordStart] = useState(true);
  const [events, setEvents] = useState([]);
  const videoRef = useRef(null);
  const videoType = "video/webm";

  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [videoChunks, setVideoChunks] = useState([]);

  const [blocks, setBlocks] = useState([]);

  const blockMethods = {
    onChangeAlignment: (id) => {
      console.log(id);
    },
  };

  const emitEvent = () => {
    const _events = [...events];
    return rrweb.record({
      emit(event) {
        console.log("recording event", event);
        _events.push(event);
        setEvents(_events);
      },
    });
  };

  const startRecording = () => {
    setRecordStart(true);
    if (recordStart) {
      emitEvent();
    }
  };

  const stopRecording = () => {
    setRecordStart(false);

    localStorage.setItem("events", JSON.stringify(events));
    emitEvent();
  };

  useEffect(() => {
    async function getStream() {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true,
      });

      let video = videoRef.current;
      video.srcObject = stream;
      video.play();

      const mediaRecorder = new MediaRecorder(stream, {
        mimeType: videoType,
      });

      setMediaRecorder(mediaRecorder);
    }

    getStream();
  }, []);

  const startVideoRecording = () => {
    console.log("Video recording started...");
    mediaRecorder.start(10);

    mediaRecorder.ondataavailable = (event) => {
      if (event.data && event.data.size > 0) {
        videoChunks.push(event.data);
      }
    };
  };

  const stopVideoRecording = async () => {
    console.log("Video recording ended!");
    try {
      mediaRecorder.stop();

      const blob = new Blob(videoChunks, { type: videoType });

      const username = "test1";
      const fileName = "filename";

      let file = new File([blob], `${username}/${fileName}`, {
        type: "video/webm",
        lastModified: Date.now(),
      });

      const {
        data: { preSignedUrl },
      } = await Axios.post(
        "https://ynqzfkim58.execute-api.us-east-1.amazonaws.com/dev/random_uuid/upload_video",
        {
          user_name: username,
          file_name: fileName,
        }
      );

      console.log("preSignedUrl", preSignedUrl);

      const result = await Axios.put(preSignedUrl, file, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log("result", result);
    } catch (error) {
      console.log("there was an error saving the video", error);
    }
  };

  const startKlen = () => {
    startRecording();
    startVideoRecording();
  };

  const stopKlen = async () => {
    stopRecording();
    await stopVideoRecording();
    setTimeout(() => {
      window.location.replace("/recordings");
    }, 2000);
  };

  const onHandleBlockRender = (item) => {
    const selectedBlock = data
      .map((datum) => {
        if (datum.type === item.type) {
          return {
            ...datum,
            type: item.type,
            pos: {
              x: 200,
              y: 200,
            },
            id: `${item.type}-${uuid().slice(0, 6)}`,
          };
        }
        return datum;
      })
      .find((da) => da.type == item.type);

    setSelectedBlocks(selectedBlock);

    if (blocks.length === 0) {
      setBlocks([...blocks, selectedBlock]);
    } else {
      const newData = data
        .map((datum) => {
          if (datum.type === item.type) {
            return {
              ...datum,
              type: item.type,
              pos: {
                x: blocks[blocks.length - 1].pos.x,
                y: blocks[blocks.length - 1].pos.y + 20,
              },
              id: `${item.type}-${uuid().slice(0, 6)}`,
            };
          }
          return datum;
        })
        .find((da) => da.type == item.type);
      setBlocks([...blocks, newData]);
    }
  };

  const handleStop = (e, id) => {
    const pos = {
      x: e.x,
      y: e.y,
    };

    const currentNode = blocks.map((block) => {
      if (block.id === id) {
        block.pos = pos;
      }
      return block;
    });

    setBlocks(currentNode);
  };

  const onHandledelete = (id) => {
    const newData = blocks.filter((block) => {
      return block.id !== id;
    });
    console.log("the blocks", blocks);
    console.log("the id", id, "the new data", newData);
    setBlocks(newData);
  };

  const onChangeText = (e, id) => {
    e.preventDefault();
    const newData = blocks.map((block) => {
      if (block.id === id && block.type === "text") {
        return {
          ...block,
          data: {
            body: e.target.value,
          },
        };
      }
      return block;
    });

    setBlocks(newData);
  };

  const showCanvasFormatter = (e) => {
    e.stopPropagation();
    const selectedBlock = data
      .map((datum) => {
        if (datum.type === "canvas") {
          return datum;
        }
        return datum;
      })
      .find((da) => da.type == "canvas");

    setSelectedBlocks(selectedBlock);
  };

  const onToggleSelectedItem = (e, id) => {
    // console.log({e})
    e.target.stopPropagation();
  
    console.log(id, data);

    const selectedBlock = blocks.find((da) => da.id === id);

    console.log({ selectedBlock });
    setSelectedBlocks(selectedBlock);
  };

  const renderBlocks = (datum) => {
    switch (datum.type) {
      case "text":
        return (
          <TextComponent
            data={datum}
            onDragStop={handleStop}
            key={datum.id}
            onHandledelete={() => onHandledelete(datum.id)}
            onChangeText={onChangeText}
            onSelected={(e) => onToggleSelectedItem(e, datum.id)}
          />
        );
      case "editor":
        return (
          <Editor
            data={datum}
            onDragStop={handleStop}
            key={datum.id}
            onSelected={(e) => onToggleSelectedItem(e, datum.id)}
          />
        );
      case "shape":
        return (
          <Shapes
            data={datum}
            onDragStop={handleStop}
            key={datum.id}
            onSelected={(e) => onToggleSelectedItem(e, datum.id)}
          />
        );
      case "image":
        return (
          <ImageUploader
            data={datum}
            onDragStop={handleStop}
            key={datum.id}
            onSelected={(e) => onToggleSelectedItem(e, datum.id)}
          />
        );
    }
  };



  useEffect(() => {
    console.log(selectedBlocks)
  }, [selectedBlocks])

  return (
    <div
      className="canvas__wrapper"
      ref={containerRef}
      onPointerMove={(event) => {
        updateMyPresence({
          cursor: mouseEventToContainerPoint(event, containerRef),
        });
      }}
      onPointerLeave={() => {
        updateMyPresence({ cursor: null });
      }}
    >
      <CanvasHeaderWrapper onHandleBlockRender={onHandleBlockRender} />
      <KlenRecorder startKlen={startKlen} stopKlen={stopKlen} />
      <BlockFormatter selectedBlock={selectedBlocks} {...blockMethods} />
      <div className="canvas" onClick={showCanvasFormatter}>
        {cursors.map(({ x, y, connectionId }) => {
          return (
            <>
              <Cursor
                key={connectionId}
                color={COLORS[connectionId % COLORS.length]}
                x={x}
                y={y}
              />
            </>
          );
        })}

        {others.map(({ connectionId, presence }) => {
          if (presence == null || presence.cursor == null) {
            return null;
          }

          return (
            <Cursor
              key={`cursor-${connectionId}`}
              color={COLORS[connectionId % COLORS.length]}
              x={presence.cursor.x}
              y={presence.cursor.y}
            />
          );
        })}
        <div className="avatars">
          {users.slice(0, 3).map(({ connectionId, info }) => {
            return (
              <Avatar
                key={connectionId}
                picture={info?.picture}
                name={info?.name}
              />
            );
          })}

          {hasMoreUsers && <div className="more">+{users.length - 3}</div>}

          {currentUser && (
            <div className="current_user_container">
              <Avatar picture={currentUser.info?.picture} name="You" />
            </div>
          )}
        </div>
        {blocks.map((datum) => {
          return renderBlocks(datum);
        })}
      </div>

      <Draggable>
        <div className="rr-block">
          <div>
            <video
              muted
              style={{ width: 400, borderRadius: "50%" }}
              ref={videoRef}
            >
              Video stream not available.
            </video>
          </div>
        </div>
      </Draggable>
    </div>
  );
};

function Avatar({ picture, name }) {
  return (
    <div className="avatar" data-tooltip={name}>
      <img
        src={picture}
        height={IMAGE_SIZE}
        width={IMAGE_SIZE}
        className="avatar_picture"
      />
    </div>
  );
}

export default memo(Canvas);
